var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-discuss-question" }, [
    _vm.showHeader
      ? _c("div", { staticClass: "mb40" }, [
          _c("div", { staticClass: "yxtbiz-discuss-question__title" }, [
            _vm._v(_vm._s(_vm.detail.name)),
          ]),
          _c("div", { staticClass: "yxtbiz-discuss-question__subinfo" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("pc_biz_lbl_discuss_content").d("讨论说明")) +
                "\n    "
            ),
          ]),
          _c("div", { staticClass: "yxtbiz-discuss-question__content" }, [
            _vm._v(_vm._s(_vm.detail.content)),
          ]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "yxtbiz-discuss-question__subtitle" }, [
      _c("span", [
        _vm._v(_vm._s(_vm.$t("pc_biz_lbl_discuss_question").d("讨论问题"))),
      ]),
      !_vm.isPreview
        ? _c("span", { staticClass: "complete-status" }, [
            _vm._v(
              _vm._s(_vm.$t("pc_biz_ai_lbl_complete")) +
                " " +
                _vm._s(_vm.completeCount) +
                "/" +
                _vm._s(_vm.discussPostList.length)
            ),
          ])
        : _vm._e(),
    ]),
    _c("div", [
      _c(
        "div",
        { staticClass: "yxtbiz-discuss-question__tab" },
        _vm._l(_vm.discussPostList, function (question, index) {
          return _c(
            "div",
            {
              key: question.postId,
              staticClass: "yxtbiz-discuss-question__tab__item",
              class: {
                "yxtbiz-discuss-question__tab__item--active":
                  _vm.currentIndex === index,
              },
              on: {
                click: function ($event) {
                  return _vm.changeTab(index)
                },
              },
            },
            [
              _c("span", [_vm._v("Q" + _vm._s(index + 1))]),
              _vm.showComplete
                ? _c("yxt-svg", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: question.complete,
                        expression: "question.complete",
                      },
                    ],
                    staticClass: "ml4",
                    attrs: {
                      width: "14px",
                      height: "14px",
                      "icon-class": "message-success",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _vm.discussPostList[_vm.currentIndex]
        ? _c("div", { staticClass: "yxtbiz-discuss-question__detail" }, [
            _c(
              "div",
              { staticClass: "yxtbiz-discuss-question__detail__content" },
              [
                _c("pre", [
                  _vm._v(_vm._s(_vm.discussPostList[_vm.currentIndex].title)),
                ]),
              ]
            ),
            _vm.discussPostList[_vm.currentIndex].attachmentList
              ? _c(
                  "div",
                  [
                    _c("yxtbiz-attachment-list", {
                      attrs: {
                        list: _vm.discussPostList[_vm.currentIndex]
                          .attachmentList,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.showSpeech
        ? _c(
            "div",
            { staticClass: "mt16" },
            [
              _vm.currentQuestion && _vm.currentQuestion.postId
                ? _c("discuss-speech", {
                    attrs: {
                      boardId: _vm.boardId,
                      "question-id": _vm.currentQuestion.postId,
                      "target-code": _vm.targetCode,
                      "allow-anonymous": Boolean(_vm.detail.anonymous),
                      "is-preview": _vm.isPreview,
                      "discuss-target-id": _vm.discussTargetId,
                      "speech-designated": _vm.speechOnlySelf,
                      speechUserId: _vm.userId,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }